import React, { Component } from 'react'
import {
    Container, Col, Row, Spinner, Button
} from 'reactstrap'
import ItemProducto from '../itemProducto'
import BuscarProductos from './buscar'
import Product from '../utilitarios/producto'
import ReactPixel from 'react-facebook-pixel'
import './productos.css'
const producto = new Product()
ReactPixel.fbq('track', 'PageView')

class Productos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            productos: [],
            loadingProductos: true,
            buscarProducto: '',
            productoCategoria: null,
            loadingMasProductos: false,
            ocultarBtnMasProductos: true
        }
        this.onChangeSearch = this.onChangeSearch.bind(this)
        this.buscarProducto = this.buscarProducto.bind(this)
        this.siguiente = this.siguiente.bind(this)
        this.anterior = this.anterior.bind(this)
        this.masProductos = this.masProductos.bind(this)
    }

    onChangeSearch(buscarProducto = '') {
        this.setState({
            buscarProducto
        })
    }

    buscarProducto(prod = this.state.buscarProducto) {
        //if (this.state.buscarProducto != '' && this.state.buscarProducto != undefined) prod = this.state.buscarProducto.toString()
        //console.log('buscarProducto: ', prod)

        this.setState({ buscando: true })

        if (typeof prod === 'object' || prod === '' || prod === undefined) {
            return this.leerProductos()
        } else {
            ReactPixel.fbq('track', 'Search')
            producto.buscar(prod)
                .then(productos => {
                    let message
                    if (productos.length === 0) {
                        message = `No se encontraron resultados para "${prod}"`
                    }
                    this.setState({
                        productos,
                        buscando: false,
                        loadingProductos: false,
                        message,
                        ocultarBtnMasProductos: true
                    })

                })
                .catch(error => console.error('Error: ', error))
        }

    }

    verificarParametros() {

    }

    leerProductos() {
        const _this = this
        const parametros = {
            atributo: "Descripcion",
            orden: "asc",
            adm: this.props.adm,
            categoria: this.props.match && this.props.match.params.categoria
        }
        //console.log(this.state.productoCategoria)
        producto.getProducts(parametros)
            .then(productos => {
                let message
                if (productos.length === 0) {
                    message = 'No hay productos para ésta categoria'
                }
                _this.setState({
                    productos,
                    loadingProductos: false,
                    buscando: false,
                    message,
                    ocultarBtnMasProductos: false
                })
            })
            .catch(error => console.error('Error: ', error))
    }

    anterior() {
        const _this = this
        const parametros = {
            atributo: "Descripcion",
            orden: "asc",
            adm: this.props.adm,
            ultimo: this.state.productos[this.state.productos.length - 1]
        }
        producto.getProductsBack(parametros).then(productos => {
            _this.setState({
                productos,
                loadingProductos: false,
                buscando: false
            })
                .catch(error => console.error('Error: ', error))
        })
    }



    siguiente() {
        const _this = this
        const parametros = {
            atributo: "Descripcion",
            orden: "asc",
            adm: this.props.adm,
            ultimo: this.state.productos[this.state.productos.length - 1]
        }
        producto.getProductsNext(parametros).then(productos => {
            _this.setState({
                productos,
                loadingProductos: false,
                buscando: false
            })
                .catch(error => console.error('Error: ', error))
        })
    }

    masProductos() {
        const cantidad = this.state.productos.length
        this.setState({
            loadingMasProductos: true
        })
        const _this = this
        const parametros = {
            atributo: "Descripcion",
            orden: "asc",
            adm: this.props.adm,
            ultimo: this.state.productos[this.state.productos.length - 1]
        }
        producto.getProductsNext(parametros).then(productos => {
            const prods = [].concat(this.state.productos, productos)
            _this.setState({
                productos: prods,
                loadingMasProductos: false,
                buscando: false,
                ocultarBtnMasProductos: prods.length == cantidad
            })

        })
            .catch(error => console.error('Error: ', error))
    }

    componentDidUpdate() {
        if (this.props.match) {
            if (this.state.productoCategoria != this.props.match.params.categoria) {
                this.setState({
                    loadingProductos: true,
                    productoCategoria: this.props.match.params.categoria
                })
                this.leerProductos()
            }
            if (this.props.match.params.search != undefined || this.props.match.params.search != '' || this.props.match.params.search != 'object') {
                if (this.state.buscarProducto != this.props.match.params.search) {
                    this.setState({
                        buscarProducto: this.props.match.params.search
                    })
                    return this.buscarProducto(this.props.match.params.search)
                }

            }
        } else if (!this.props.match) {
            if (this.state.productoCategoria != null) {
                this.setState({
                    loadingProductos: true,
                    productoCategoria: null
                })
                this.leerProductos()
            }
        }

    }

    componentWillReceiveProps(nextProps) {
        nextProps.update && this.leerProductos()
    }


    componentWillMount() {
        //console.log(this.props.match.params.search)

        if (this.props.match) {
            this.setState({
                productoCategoria: this.props.match.params.categoria
            })
            if (this.props.match.params.search != undefined && this.props.match.params.search != '') {
                return this.buscarProducto(this.props.match.params.search)
            }
        }
        this.leerProductos()
    }

    render() {
        return (
            <div>
                <Container className="Productos">
                    <Row>
                        {
                            window.location.toString().includes('productos') &&
                            <Col xs="12">
                                <BuscarProductos onChangeSearch={this.onChangeSearch} buscarProducto={this.buscarProducto} buscando={this.state.buscando} />
                            </Col>
                        }

                    </Row>
                    <Row>
                        {
                            this.state.loadingProductos ?
                                <div className="spinnerCargando">
                                    <Spinner /> Cargando...
                                </div>
                                :
                                this.state.productos.length == 0 ?
                                    <div className="spinnerCargando">
                                        {
                                            this.state.message
                                        }
                                    </div>
                                    :
                                    this.state.productos.map((item) => {
                                        return <Col xs="6" md="3" lg="3" key={item.id}><ItemProducto id={item.id} productoEditar={this.props.productoEditar} productoEliminar={this.props.productoEliminar} btnInfoDisabled={this.props.btnInfoDisabled} producto={item.data()} /></Col>
                                    })
                        }
                    </Row>
                    <Row>
                        {
                            !this.state.ocultarBtnMasProductos &&
                            <div className="btnVerMasProductos">
                                {
                                    this.state.loadingMasProductos ?
                                        <div className="d-flex justify-content-center">
                                            <Spinner type="grow" style={{ width: '3rem', height: '3rem' }} color="warning" />{' '}
                                            <Spinner type="grow" style={{ width: '3rem', height: '3rem' }} color="warning" />{' '}
                                            <Spinner type="grow" style={{ width: '3rem', height: '3rem' }} color="warning" />
                                        </div>
                                        :
                                        <Button onClick={this.masProductos} disabled={this.state.loadingMasProductos} size="sm" color="warning" block>Mostrar más</Button>

                                }
                            </div>
                        }
                    </Row>


                </Container>
            </div>

        )
    }
}

export default Productos;